class DrawerUpsells extends HTMLElement {
    constructor() {
      super();
  
      this.header = this.querySelector(".drawer-upsells__header");
      this.toggleIcon = this.querySelector(".drawer-upsells__toggle-icon");
  
      this.setMaxWidth();
  
      if (typeof Swiper !== "undefined" && typeof subscribe !== "undefined")
        this.init();
  
      this.toggleIcon.addEventListener("click", (e) => {
        this.classList.toggle("expanded");
        e.stopPropagation();
      });
  
      this.header.addEventListener("click", () => {
        if (this.classList.contains("expanded")) return;
        else this.classList.toggle("expanded");
      });
  
      document.addEventListener("DOMContentLoaded", this.init.bind(this));
  
      const resizeObserver = new ResizeObserver(() => {
        this.setMaxWidth();
      });
  
      resizeObserver.observe(this.drawer);
    }
  
    cartUpdateUnsubscriber = undefined;
  
    setMaxWidth() {
      this.style.display = "none";
  
      this.drawer = this.closest(".drawer__inner");
  
      if (!this.drawer) return;
  
      this.drawerWidth = this.drawer.getBoundingClientRect().width;
  
      this.style.display = "block";
  
      this.style.maxWidth = this.drawerWidth + "px";
    }
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (event) => {
          this.init();
        }
      );
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    init() {
      this.upsellsSlider = new Swiper(".drawer-upsells__slider", {
        slidesPerView: "auto",
        spaceBetween: 24,
        slidesOffsetBefore: 33,
        slidesOffsetAfter: 33,
        mousewheel: { invert: true },
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: ".drawer-upsells__prev",
          nextEl: ".drawer-upsells__next",
        },
      });
  
      this.upsellsSlider.navigation.init();
    }
  }
  
  customElements.define("drawer-upsells", DrawerUpsells);
  